import { render, staticRenderFns } from "./Typingtips.vue?vue&type=template&id=3d5f88b5&scoped=true"
var script = {}
import style0 from "./Typingtips.vue?vue&type=style&index=0&id=3d5f88b5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5f88b5",
  null
  
)

export default component.exports